<template lang="pug">
#map-popup.white-popup.mfp-hide.view_map
  #map.map(style='width: 100%; height: 100%; position: inherit;')
</template>

<script src="//dapi.kakao.com/v2/maps/sdk.js?appkey=7266da0f504c71a0b97051295b15e1a0&libraries=services"></script>
<script>
export default {
  data() {
    return {};
  },
  props: ['addr'],
  computed: {},
  methods: {
    initMap() {
      const container = document.getElementById('map');
      // 주소-좌표 변환 객체를 생성합니다
      var geocoder = new kakao.maps.services.Geocoder();
      // 주소로 좌표를 검색합니다
      var addr = this.addr;
      geocoder.addressSearch(addr, function (result, status) {
        // 정상적으로 검색이 완료됐으면
        if (status === kakao.maps.services.Status.OK) {
          var coords = new kakao.maps.LatLng(result[0].y, result[0].x);
          const options = {
            // 지도 중심 좌표
            center: coords,
            // 지도 레벨 (확대, 축소의 정도)
            level: 3,
          };
          var map = new kakao.maps.Map(container, options);
          // 결과값으로 받은 위치를 마커로 표시합니다
          var marker = new kakao.maps.Marker({
            position: coords,
          });
          marker.setMap(map);
        }
      });
    },
  },
  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement('script');

      script.onload = () => kakao.maps.load(this.initMap);
      script.src =
        '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=7266da0f504c71a0b97051295b15e1a0&libraries=services';
      document.head.appendChild(script);
    }
  },
};
</script>
<style>
.view_map {
  height: 400px;
}
#map-popup {
  height: 400px;
}
.modal-container {
  width: 800px;
  height: 432px;
  padding: 0 10px;
}
@media (max-width: 800px) {
  .modal-container {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .modal-container {
    /* width: ; */
    height: 232px;
  }
  #map-popup {
    height: 200px;
  }
}
</style>
